import endpoints from "constants/endpoints";
import { adminApi } from "services/api/client";

export const joinForum = async (data) => {
  return await adminApi({
    endpoint: `${endpoints.JOIN_FORUM}${data.id}/`,
    method: "post",
    data: data,
  });
};

export const createAnswer = async (data) => {
  const payload = { ...data, image: data.image?.[0] };
  return await adminApi({
    endpoint: `${endpoints.ANSWERS}${data.question_id}/`,
    method: "post",
    data: payload,
  });
};

export const updateAnswer = async (data) => {
  const payload = {
    answer: data.answer,
    image: Array.isArray(data.image) ? data.image[0] : data.image,
  };
  return await adminApi({
    endpoint: `${endpoints.ANSWERS}${data.question_id}/${data.id}/`,
    method: "patch",
    data: payload,
  });
};

export const getQuestions = async (data) => {
  return await adminApi({
    endpoint: `${endpoints.QUESTIONS}${data.course_id}/${data.forum_id}/`,
    method: "get",
  });
};

export const getUnansweredQuestions = async () => {
  return await adminApi({
    endpoint: `${endpoints.UNANSWERED_QUESTIONS}`,
    method: "get",
  });
};

export const getQuestionDetails = async (data) => {
  return await adminApi({
    endpoint: `${endpoints.QUESTION_DETAILS}${data.question_id}/`,
    method: "get",
  });
};
